import { render, staticRenderFns } from "./FormItemOverlay.vue?vue&type=template&id=2aaa349d&scoped=true"
import script from "./FormItemOverlay.vue?vue&type=script&lang=js"
export * from "./FormItemOverlay.vue?vue&type=script&lang=js"
import style0 from "./FormItemOverlay.vue?vue&type=style&index=0&id=2aaa349d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaa349d",
  null
  
)

export default component.exports